import { MessageBox } from '@meta-vue/element-ui'
import { refreshWindowAndClearMemory, setPolling } from '../util/tools'
// 初始设置的变量和函数
let lastActiveTime = Date.now()
let warnFlag = false
let userActivityPolling = null
const timeoutDuration = 30 * 1000 * 60 // 30 minutes in milliseconds
// const timeoutDuration = 10000 // 2 minutes in milliseconds

export function beforeAppMount() {
  const wbRefreshMode = window.localStorage?.getItem('wb-refresh-mode')
  if (wbRefreshMode) {
    window.localStorage.removeItem('wb-refresh-mode')
    window.lib?.track?.metric?.('点击按钮刷新页面', wbRefreshMode)
  }
  userActivityPolling = setPolling(
    () => {
      checkUserActivity()
    },
    10000,
    { from: '用户无操作超时轮循', ignoreBackgrounder: false, ignoreOffline: false }
  )

  setupEventListeners()
}

function checkOverMemory() {
  const memoryInfo = performance.memory || { jsHeapSizeLimit: 0, totalJSHeapSize: 0, usedJsHeapSize: 0 }
  // 上下文内可用堆的最大体积
  const limitedJS = Math.round((memoryInfo.jsHeapSizeLimit / 1024) * 1024)
  // 当前 JS 堆活跃段（segment）的体积
  const usedJS = Math.round((memoryInfo.usedJSHeapSize / 1024) * 1024)
  return Math.ceil((usedJS / limitedJS) * 100) > 25
}
function checkUserActivity() {
  if (warnFlag) return
  const currentTime = Date.now()
  // console.log('长时间未操作时间', currentTime - lastActiveTime)
  if (currentTime - lastActiveTime > timeoutDuration && checkOverMemory()) {
    warnFlag = true
    destroy()
    window.lib?.track?.metric?.('超过半小时未操作超时处理弹窗打开', 'userActivityTracker-refresh-confirm')
    console.log('超过半小时未操作超时处理')
    MessageBox.confirm('检测到您超过半小时未操作，建议您刷新页面保持工作台流畅运行！', '提示', {
      confirmButtonText: '刷新页面',
      cancelButtonText: '继续使用',
      type: 'warning',
      closeOnClickModal: false,
      showClose: false
    })
      .then(() => {
        // 半小时未操作超时处理
        window.localStorage?.setItem('wb-refresh-mode', 'userActivityTracker-refresh-window')
        // 重开式打开页面，绝对清除内存占用
        refreshWindowAndClearMemory()
      })
      .catch(e => {
        console.warn(e)
        updateLastActiveTime()
        warnFlag = false
        window.lib?.track?.metric?.('继续使用工作台', 'userActivityTracker-refresh-cancel')
      })
  }
}

function updateLastActiveTime() {
  lastActiveTime = Date.now()
}

function setupEventListeners() {
  document.addEventListener('mousemove', updateLastActiveTime)
  document.addEventListener('keydown', updateLastActiveTime)
  document.addEventListener('click', updateLastActiveTime)
  document.addEventListener('scroll', updateLastActiveTime)
}

function destroy() {
  console.log('destroy', userActivityPolling)
  if (userActivityPolling) {
    userActivityPolling.clear()
  }
  document.removeEventListener('mousemove', updateLastActiveTime)
  document.removeEventListener('keydown', updateLastActiveTime)
  document.removeEventListener('click', updateLastActiveTime)
  document.removeEventListener('scroll', updateLastActiveTime)
  window.removeEventListener('beforeunload', destroy)
}

window.addEventListener('beforeunload', destroy)
